import { addModuleStyles } from '@glu/theming/glu-css-override';

const themeKey = 'legacyListBuilder';

const defaultTheme = ({ legacy, palette }) => (legacy ? undefined : {
  backgroundColor: palette.background,
  body: {
    fontFamily: '\'Roboto\', Helvetica, Arial, sans-serif',
    fontSize: '14px',
    color: '#333333',
    fontWeight: 400
  },
  colors: {
    draggingStateColor: palette.text.light,
    checkmarkIconColor: palette.text.light,
    borderColor: '#ededed',
    primaryColor: palette.primary.normal
  },
  sectionsBaseStyles: {
    fontFamily: '\'Roboto Condensed\', \'Roboto\', Helvetica, Arial, sans-serif',
    fontSize: '16px',
    fontWeight: 700,
    textTransform: 'uppercase'
  }
});

const styles = ({ legacyListBuilder }) => {
  if (!legacyListBuilder) {
    return {};
  }

  const {
    body,
    backgroundColor,
    colors,
    sectionsBaseStyles
  } = legacyListBuilder;
  return {
    root: {
      '& .list-builder': {
        backgroundColor,
        display: 'flex',
        color: '#333333',
        textDecoration: 'none solid rgb(51, 51, 51)',
        '& .source-section': {
          marginRight: 0,
          width: '50%',
          '& ul.source-list': {
            outline: 'none',
            height: '487px'
          },
          '& fieldset': {
            borderRight: `2px solid ${colors.borderColor}`,
            borderTop: `2px solid ${colors.borderColor}`,
            borderBottom: `2px solid ${colors.borderColor}`
          }
        },
        '& .destination-section': {
          '& .target-section-header': {
            marginLeft: '20px'
          },
          '& ul.target-list': {
            outline: 'none',
            height: '487px',
            '& .list-builder-flex-wrap': {
              marginLeft: '20px'
            }
          },
          '& fieldset': {
            borderLeft: `2px solid ${colors.borderColor}`,
            borderTop: `2px solid ${colors.borderColor}`,
            borderBottom: `2px solid ${colors.borderColor}`
          }
        },
        '& .empty-block': {
          height: '35px',
          width: '61px'
        },
        '& .manage-links': {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          borderTop: `2px solid ${colors.borderColor}`,
          borderBottom: `2px solid ${colors.borderColor}`,
          height: '491px',
          '& > div': {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            '& .icon-wrapper': {
              width: '32px',
              height: '32px',
              backgroundColor,
              border: 'none',
              '&:first-child': {
                marginBottom: '26px'
              },
              '& svg': {
                width: '32px',
                height: '32px',
                fill: colors.primaryColor
              }
            }
          }
        },
        '& .source-section-header': {
          ...sectionsBaseStyles,
          position: 'relative',
          '& .source-list-search-filter': {
            bottom: '0px',
            marginLeft: '15px'
          },
          '& .source-list-search-filter-toggle': {
            padding: 0,
            '& .icon-search': {
              paddingLeft: '10px',
              '& svg': {
                fill: colors.primaryColor
              }
            }
          }
        },
        '& .target-section-header': {
          ...sectionsBaseStyles
        },
        '& .list-builder-item': {
          '& .list-builder-item-content': {
            fontSize: body.fontSize,
            fontWeight: body.fontWeight,
            textTransform: 'uppercase',
            paddingLeft: '10px',
            display: 'inline-block'
          },
          '& .list-builder-flex-wrap': {
            backgroundColor,
            border: 'none',
            marginTop: 0,
            marginBottom: 0,
            borderBottom: '1px solid #ccc',
            height: '61px',
            lineHeight: '51px',
            '& input[type=checkbox]': {
              top: '20px'
            },
            marginLeft: 0,
            display: 'flex',
            justifyContent: 'flex-start',
            paddingLeft: '8px',
            paddingRight: '22px',
            '& .list-builder-flex-item': {
              '&:last-child': {
                display: 'flex',
                justifyContent: 'flex-end',
                flex: '1 0 auto',
                '& .drag-icon-wrapper': {
                  position: 'initial'
                }
              }
            }
          },
          '& label.checkbox-wrapper': {
            display: 'inline-block',
            position: 'relative',
            paddingLeft: '15px',
            marginBottom: '12px',
            cursor: 'pointer',
            fontSize: '22px',
            userSelect: 'none',
            '& input': {
              position: 'absolute',
              opacity: 0,
              cursor: 'pointer',
              height: 0,
              width: 0,
              '&:checked': {
                '& ~ .checkmark': {
                  backgroundColor: '#4c4c4c',
                  '& .icon-wrapper': {
                    display: 'block',
                    '& svg': {
                      display: 'block',
                      fill: colors.checkmarkIconColor,
                      width: '10px',
                      height: '9px',
                      top: '2px',
                      left: '2px',
                      position: 'absolute'
                    }
                  }
                }
              }
            },
            '& .checkmark': {
              '& .icon-wrapper': {
                display: 'none'
              }
            }
          },
          '& .checkmark': {
            position: 'absolute',
            top: 0,
            left: 0,
            height: '16px',
            width: '16px',
            border: '1px solid #757575',
            borderRadius: '2px',
            backgroundSize: 'cover'
          },
          '&.ui-draggable-dragging': {
            '& .list-builder-flex-wrap': {
              backgroundColor: colors.primaryColor,
              backgroundSize: 'cover',
              boxShadow: '0px 0px 10px rgba(0,0,0,0.2)',
              color: colors.draggingStateColor,
              borderBottom: 'none',
              '& .checkbox-wrapper': {
                backgroundColor,
                '& .checkmark': {
                  backgroundColor,
                  border: `1px solid ${colors.draggingStateColor}`
                },
                '& input': {
                  '&:checked': {
                    '& ~ .checkmark': {
                      backgroundColor,
                      '& .icon-wrapper': {
                        '& svg': {
                          fill: colors.primaryColor
                        }
                      }
                    }
                  }
                }
              },
              '& .icon-wrapper': {
                '& svg': {
                  fill: colors.checkmarkIconColor
                }
              }
            }
          }
        }
      }
    }
  };
};

addModuleStyles(styles, themeKey, defaultTheme);
